export const appErrors = {
  2016: { message: "Deposit not enabled yet." },
  2057: { message: "Duplicate recipient" },
  "002001": { message: "Card not found" },
  2013: { message: "Daily transfer limit reached" },
  2012: { message: "Insufficient funds" },
  2055: { message: "Invalid Routing Number"}
};
